import { useTranslation } from 'react-i18next';

import { CollectionForm } from './CollectionForm';
import { MetaPanel } from './MetaPanel';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/Card';
import { MerchandisingCollection } from '@/services/MerchandisingCollectionsService';

interface CollectionInfoProps {
  collection: MerchandisingCollection;
}

export function CollectionInfo({ collection }: CollectionInfoProps) {
  const { t } = useTranslation('translation', {
    keyPrefix:
      'pages.MerchandisingCollections.pages.Collection.components.CollectionInfo',
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('title')}</CardTitle>
        <CardDescription>{t('description')}</CardDescription>
      </CardHeader>

      <CardContent>
        <div className="space-y-4">
          <CollectionForm collection={collection} />
          <MetaPanel collection={collection} />
        </div>
      </CardContent>
    </Card>
  );
}
